var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.status===1)?_c('b-badge',{attrs:{"variant":"success"}},[_vm._v("فعال")]):_vm._e(),(_vm.status===0)?_c('b-badge',{attrs:{"variant":"danger"}},[_vm._v("غیر فعال")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }